import { Text } from '@simplywallst/ui-core';
import { Badge } from '@/pages/CompanyReport/components/Introduction/components/KeyInformation';
import type { ReactNode } from 'react';

interface KeyMetrics {
  title: string;
  value: string;
  tooltip?: string | null;
}

interface KeyMetricsBadge {
  title: string;
  value: ReactNode;
  tooltip?: string | null;
}

export const addBadge = (keyMetrics: KeyMetrics[]): KeyMetricsBadge[] => {
  const badgeValues = {
    Appropriate: 'positive',
    Sufficient: 'positive',
    Good: 'positive',
    High: 'warning',
    Low: 'warning',
    None: 'none',
  };
  return keyMetrics.map((metric) => {
    if (badgeValues.hasOwnProperty(metric.value))
      return {
        ...metric,
        value: (
          <Text typography="tiny">
            <Badge styleType={badgeValues[metric.value]}>{metric.value}</Badge>
          </Text>
        ),
      };
    return {
      ...metric,
    };
  });
};
